import cn from 'classnames';
import VerdictPassIcon from '@/assets/icons/verdict-pass.svg?react';
import VerdictCautionIcon from '@/assets/icons/verdict-caution.svg?react';
import VerdictRedFlagIcon from '@/assets/icons/verdict-red-flag.svg?react';
import type { VerdictCalloutBlock as VerdictCalloutBlockType } from '../types';
import { BlockEmptyState } from './BlockEmptyState';

// ─────────────────────────────────────────────
// VerdictCalloutBlock — 审计结论
// Figma: node-id=10426-25629
// verdict: 'pass'=绿色 / 'caution'=橙色 / 'red_flag'=红色
// ─────────────────────────────────────────────

type VerdictType = 'pass' | 'caution' | 'red_flag';

const styleMap: Record<VerdictType, { bg: string; border: string; text: string }> = {
  pass: {
    bg: 'bg-[#ECFDF5]',
    border: 'border-[#A7F3D0]',
    text: 'text-[#047857]',
  },
  caution: {
    bg: 'bg-[#FFFBEB]',
    border: 'border-[#FDE68A]',
    text: 'text-[#B45309]',
  },
  red_flag: {
    bg: 'bg-[#FEF2F2]',
    border: 'border-[#FECACA]',
    text: 'text-[#B91C1C]',
  },
};

const iconMap: Record<VerdictType, React.FC<React.SVGProps<SVGSVGElement>>> = {
  pass: VerdictPassIcon,
  caution: VerdictCautionIcon,
  red_flag: VerdictRedFlagIcon,
};

export function VerdictCalloutBlock({ block }: { block: VerdictCalloutBlockType }) {
  const { verdict, summary } = block;
  if (!verdict || !summary) return <BlockEmptyState label="审计结论" />;

  const style = styleMap[verdict] ?? styleMap.caution;
  const Icon = iconMap[verdict] ?? iconMap.caution;

  return (
    <div className={cn('flex items-center gap-3 rounded-xl border px-5 py-4', style.bg, style.border)}>
      {/* 图标 */}
      <Icon className="w-6 h-6 flex-shrink-0" />
      <p className={cn('text-base font-medium leading-[1.5] flex-1', style.text)}>{summary}</p>
    </div>
  );
}
